// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconEwiEwiColoredDarkWarningTriangle_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.2519 1.43277C7.58803 0.855743 8.41197 0.855743 8.7481 1.43277L15.8781 13.6726C16.2199 14.2593 15.8024 15 15.13 15H0.869994C0.197591 15 -0.219866 14.2593 0.121893 13.6726L7.2519 1.43277Z" fill="#FDCA40"/>
  <path d="M9 5 7 5.65217V10H9V5ZM9 11H7V13H9V11Z" fill="#1A2329"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.8778 1.64916C11.382 0.783614 12.618 0.783615 13.1222 1.64916L23.8172 20.0089C24.3298 20.8889 23.7036 22 22.695 22H1.30499C0.296386 22 -0.329799 20.8889 0.182839 20.0089L10.8778 1.64916Z" fill="#FDCA40"/>
  <path d="M13 7 10.5 8.04348V15H13V7ZM13 17H10.5V19.5H13V17Z" fill="#1A2329"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.5038 2.89645C15.1761 1.70118 16.8239 1.70118 17.4962 2.89645L31.7562 28.2504C32.4397 29.4657 31.6048 31 30.26 31H1.73999C0.395181 31 -0.439731 29.4657 0.243785 28.2504L14.5038 2.89645Z" fill="#FDCA40"/>
  <path d="M17 10 14 11.4348V21H17V10ZM17 24H14V27H17V24Z" fill="#1A2329"/>
</svg>
`;
/**
 * IconEwiEwiColoredDarkWarningTriangle is a generated icon component.
 */
let IconEwiEwiColoredDarkWarningTriangle = IconEwiEwiColoredDarkWarningTriangle_1 = class IconEwiEwiColoredDarkWarningTriangle extends IconBaseElement {
    render() {
        return html `${IconEwiEwiColoredDarkWarningTriangle_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconEwiEwiColoredDarkWarningTriangle.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconEwiEwiColoredDarkWarningTriangle = IconEwiEwiColoredDarkWarningTriangle_1 = __decorate([
    customElement('zui-icon-ewi-ewi-colored-dark-warning-triangle')
], IconEwiEwiColoredDarkWarningTriangle);
export { IconEwiEwiColoredDarkWarningTriangle };
